import Box from "@mui/material/Box"
import type { SxProps, Theme } from "@mui/material/styles"
import type { ReactNode } from "react"

import type { SxStyles } from "@/types/util"
import SplitBackground from "../atoms/split_background"

const styles = {
  container: (theme: Theme) => ({
    display: "flex",
    alignSelf: "center",
    justifyContent: "center",
    flexDirection: "column",
    [theme.breakpoints.up("desktop")]: {
      marginTop: "80px",
      alignItems: "center",
      marginLeft: "auto",
      marginRight: "auto",
    },
    [theme.breakpoints.down("desktop")]: {
      marginTop: "16px",
      width: "94%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    "& a": {
      color: "#5698e4",
      cursor: "pointer",
      textDecoration: "none",
    },
  }),
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    backgroundColor: "white",
    boxShadow: "0 3px 3px rgba(0,0,0,.15)",
    borderRadius: "6px",
  },
  footer: {
    textAlign: "center",
    alignSelf: "center",
    color: "rgba(0,0,0,.4)",
    margin: "20px 0 20px",
  },
} satisfies SxStyles

type Props = {
  children: ReactNode
  footer?: ReactNode
  sx?: SxProps<Theme>
}

const WhiteCard = ({ children, footer, sx = {} }: Props) => {
  const containerSx: SxProps<Theme> = [styles.container, ...(Array.isArray(sx) ? sx : [sx])]
  return (
    <>
      <SplitBackground topColor="lightBlue" />
      <Box sx={containerSx}>
        <Box sx={styles.card}>{children}</Box>
        <Box sx={styles.footer}>{footer}</Box>
      </Box>
    </>
  )
}

export default WhiteCard
